import type { FaireProductEntity } from "../../entity_types/product";

export const p_exb7jfwhb7: FaireProductEntity = {
  token: "p_exb7jfwhb7",
  type: "product",
  name: "FOUNDERS",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/5edf4ba060387b51532a639487be9663b1c3b204c9490369ca0f4d5d9e694f56.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/254168e8d5a4f805519188ae48f9f6bcca6b5bf64c36e14cd80ea95489fcba71.png",
    "https://cdn.faire.com/fastly/8448babdbae88a1f90865a9019b40150b9d1bf09c2fbd6450e01c4f03e05ced0.jpeg",
    "https://cdn.faire.com/fastly/adb559d508ec9b41167e927c0055dcfc147980109da51eeba7900651f29a1a16.png",
    "https://cdn.faire.com/fastly/d3614f156fcd80fbb571f47df1ac25ddb2cfef0d5628a8cbdd79f7f1f84de326.png"
  ],
  priceDollars: 29.4,
  description: "Smooth, Sweet, Juicy\n\nThe cup we built the roastery on. Smooth and approachable, with just enough complexity to keep the second cup interesting.\n\nTasting Notes: Milk chocolate, lemon, soft fruit\nOrigin: Single-origin Colombia (rotating producer)\nProcess: Washed\nRoast Level: Medium\nRecommended Brew: Drip, pour-over, French press, or espresso\n\nCurated by the Portrait Coffee team, Founders highlights all the best parts of a cup of coffee: smooth, sweet, juicy, the kind of cup you reach for first thing. Inspired by late-night sips of Waffle House diner coffee, Founders is the daily drinker we built the roastery on. Milk chocolate sweetness lands first. Light lemon and soft fruit open up as the cup cools.\n\nWhole bean or ground, roasted to order in Atlanta. Available in 310 g, 2 lb, and 5 lb.\n",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:56.078Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
